
import * as React from "react"
import { ArrowUpDown } from "lucide-react" 
import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <div className="relative w-full">
        <textarea
          className={cn(
            "flex min-h-[150px] w-full rounded-md border border-input bg-background px-3 py-3 pb-10 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-y transition-all duration-200 hover:border-primary/70",
            className
          )}
          ref={ref}
          {...props}
        />
        <div className="absolute bottom-2 right-3 text-muted-foreground/70 pointer-events-none flex items-center text-sm">
          <ArrowUpDown className="h-4 w-4 mr-1" />
          <span>Resize</span>
        </div>
      </div>
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
